<template>
  <div class="wrapper-answer-section border border-secondary-20 rounded-lg px-6 py-7">
    <div
      class="answers-and-submissions flex flex-col gap-5"
      ref="answerRef"
    >
      <QuestionContent
        :question="question"
        :scoring="scoring"
        :order="order"
        :totalQuiz="totalQuiz"
        :scaleRange="scaleRange"
      />
      <component
        :is="answerComponent"
        :report="report"
      />
    </div>
  </div>
</template>

<script>
import QuestionContent from '@/components-v2/presentation-report/ReportAudienceDetail/QuestionContent.vue'
import TwoColumnQuizReview from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/TwoColumnQuizReview.vue'
import ShortAnswer from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ShortAnswer.vue'
import CorrectOrder from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/CorrectOrder.vue'
import MatchPair from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/MatchPair.vue'
import Poll from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/Poll.vue'
import ListSubmission from '@/components-v2/presentation-report/ReportAudienceDetail/open-question/ListSubmission.vue'
import BlockSubmission from '@/components-v2/presentation-report/ReportAudienceDetail/open-question/BlockSubmission.vue'
import RatingScale from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/RatingScale.vue'
import Categorise from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/Categorise.vue'

import constants from '@/constant'

const { INDIVIDUAL_REPORT_QUESTION_TYPE } = constants

const QUIZ_TYPES = [
  INDIVIDUAL_REPORT_QUESTION_TYPE.SHORT_ANSWER,
  INDIVIDUAL_REPORT_QUESTION_TYPE.PICK_ANSWER,
  INDIVIDUAL_REPORT_QUESTION_TYPE.MATCH_PAIRS,
  INDIVIDUAL_REPORT_QUESTION_TYPE.CORRECT_ORDER,
  INDIVIDUAL_REPORT_QUESTION_TYPE.CATEGORISE,
]

const answerComponentMap = {
  [INDIVIDUAL_REPORT_QUESTION_TYPE.WORD_CLOUD]: 'ListSubmission',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.OPEN_ENDED]: 'BlockSubmission',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.BRAIN_STORM]: 'BlockSubmission',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.SHORT_ANSWER]: 'ShortAnswer',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.SCALES]: 'RatingScale',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.CATEGORISE]: 'Categorise',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.PICK_ANSWER]: 'TwoColumnQuizReview',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.POLL]: 'Poll',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.MATCH_PAIRS]: 'MatchPair',
  [INDIVIDUAL_REPORT_QUESTION_TYPE.CORRECT_ORDER]: 'CorrectOrder',
}

export default {
  components: {
    QuestionContent,
    TwoColumnQuizReview,
    ShortAnswer,
    CorrectOrder,
    MatchPair,
    ListSubmission,
    BlockSubmission,
    RatingScale,
    Categorise,
    Poll,
  },
  props: {
    report: {
      type: Object,
      default: () => {},
    },
    order: {
      type: Number,
      default: 1,
    },
    totalQuiz: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    answerComponent() {
      const slideType = this.report.question_type || 'pickAnswer'
      return answerComponentMap[slideType]
    },
    question() {
      return {
        id: this.report.question_id,
        type: this.report.question_type,
        title: this.report.question_title,
        image: this.report.question_image,
        description: this.report.question_description,
      }
    },
    scoring() {
      const isQuizType = QUIZ_TYPES.includes(this.report.question_type)
      if (!isQuizType) return null
      return {
        result: this.report.answer_result,
        point: this.report.points_earned,
        time: this.report.time_answer,
      }
    },
    scaleRange() {
      if (this.report.question_type !== INDIVIDUAL_REPORT_QUESTION_TYPE.SCALES) return null
      let scaleRange = this.report.scale_range
      try {
        scaleRange = JSON.parse(this.report?.scale_range)
      } catch (error) {
        scaleRange = {}
      }

      // Thêm low label và value
      const result = []
      if (scaleRange.lowLabel && scaleRange.lowValue) {
        result.push({
          label: scaleRange.lowLabel,
          value: scaleRange.lowValue,
        })
      }

      // Lặp qua các key số và thêm nếu label không rỗng
      Object.keys(scaleRange)
        .filter((key) => !['lowLabel', 'lowValue', 'highLabel', 'highValue', 'mustRate', 'showAverage', 'showMidValues'].includes(key)) // chỉ giữ key là số
        .sort((a, b) => Number(a) - Number(b))
        .forEach((key) => {
          const label = scaleRange[key]
          if (label && label !== '') {
            result.push({
              label,
              value: Number(key) + 1 + (parseInt(scaleRange.lowValue, 10) || 0),
            })
          }
        })

      // Thêm high label và value
      if (scaleRange.highLabel && scaleRange.highValue) {
        result.push({
          label: scaleRange.highLabel,
          value: scaleRange.highValue,
        })
      }

      return result
    },
  },
}
</script>

<style lang="scss" scoped>
.answers-and-submissions {
  color: var(--base-90, #313131);
}
</style>
